/* eslint-disable no-shadow */
export enum PreviousYearsResultType {
  TO_RETURN = 'toReturn',
  TO_PAY = 'toPay',
  ZERO = 'zero',
  PRE_SALE = 'preSale',
  NOT_SUPPORTED = 'not_supported',
}
export const PREVIOUS_YEAR_STORAGE_KEY = 'previousYearStorageAmount';

export enum PreviousYearSatStatus {
  EMPTY = 'Vacio',
  NOT_AVAILABLE = 'No disponible',
}
export enum PreviousYearStatus {
  READY = 'ready',
  SUBMITTED = 'submitted',
  CALCULATING = 'calculating',
}
